export default {
  advancedPlanSettings: 'Advanced Plan Settings',
  minimumWeeklySpend: 'Minimum Weekly Spend',
  minSpendInfo: 'Minimum ad-spend limits for a single week, for each media channel. These limits don\'t exclude zero-ad-spend weeks.',
  cancel: 'Cancel',
  save: 'Save',
  positiveValueRequired: 'Positive value required'
}
